import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const SourceOfAppService = {
  getAllSourceOfApps(obj) {
    return httpClient.post(endPoints.getAllSourceOfApps, obj);
  },
  getAllSourceOfAppsByPagination(obj) {
    return httpClient.post(endPoints.getAllSourceOfAppsByPagination, obj);
  },
  getSourceOfAppDetail(obj) {
    return httpClient.post(endPoints.getSourceOfAppDetail, obj);
  },
  addSourceOfApp(obj) {
    return httpClient.post(endPoints.addSourceOfApp, obj);
  },
  updateSourceOfApp(obj) {
    return httpClient.post(endPoints.updateSourceOfApp, obj);
  },
  deleteSourceOfApp(obj) {
    return httpClient.post(endPoints.deleteSourceOfApp, obj);
  },
};

export default SourceOfAppService;



// WEBPACK FOOTER //
// ./src/service/SourceOfAppService.js